/* NUVA AI LAB · Tienda Lista — comportamiento de la landing (2026-10-08). Solo lo carga layout/nlab.liquid.
   1) Barra fija en móvil [data-nlab-barra]: visible solo cuando la portada y el cierre [data-nlab-zona] no están en pantalla.
   2) Encabezado [data-nlab-header]: borde inferior cuando la portada sale de la vista.
   MEDICIÓN: aquí no se envía ningún evento propio. El botón de inscripción está inactivo (paso 3, vista previa).
   Sin IntersectionObserver no se hace nada: la página se lee completa y la barra queda oculta. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  /* 1) Barra fija en móvil */
  var barra = document.querySelector('[data-nlab-barra]');
  var zonas = document.querySelectorAll('[data-nlab-zona]');
  if (barra && zonas.length) {
    var enPantalla = new Set();
    var actualizar = function () {
      var mostrar = enPantalla.size === 0;
      barra.classList.toggle('is-visible', mostrar);
      barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      if (mostrar) { barra.removeAttribute('inert'); } else { barra.setAttribute('inert', ''); }
    };
    var ioZonas = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { enPantalla.add(e.target); } else { enPantalla.delete(e.target); }
      });
      actualizar();
    });
    zonas.forEach(function (z) { ioZonas.observe(z); });
  }

  /* 2) Encabezado */
  var header = document.querySelector('[data-nlab-header]');
  var portada = document.getElementById('nlab-inicio');
  if (header && portada) {
    new IntersectionObserver(function (entradas) {
      header.classList.toggle('is-fijo', !entradas[0].isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px' }).observe(portada);
  }
})();
